import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import useLocalization from 'localization';
const Span = ({ children, strong = false, styles }) => {
    const { t } = useLocalization();
    const { typography } = useTheme();
    const mergedStyles = useMemo(() => ({
        ...(strong && typography.strong),
        ...styles
    }), [styles, strong, typography]);
    return (React.createElement("span", { style: mergedStyles }, typeof children === 'string' ? t(String(children)) : children));
};
export default Span;
//# sourceMappingURL=index.js.map